
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[file]",
      function () {
        return require("private-next-pages/[file].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[file]"])
      });
    }
  